import { createAction, props } from '@ngrx/store';

export const setQuote = createAction('[QUOTE] Set Quote', props<{ quote }>());

export const editQuote = createAction('[QUOTE] Edit Quote', props<{ id: number; quote }>());

export const setCurrentStep = createAction(
  '[QUOTE] Set Current Step',
  props<{ currentStep: number }>()
);

export const addToPrevious = createAction('[QUOTE] add toPrevious');
